import { AuthServiceCustom } from '../../../shared/service/auth.service';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public auth: AuthServiceCustom) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        request = request.clone({
            setHeaders: {
                Authorization: 'Bearer ' + this.auth.AccessToken
            }
        });
        return next.handle(request)
            .pipe(
                tap(event => {
                    if (event instanceof HttpResponse) {
                    }
                }, error => {
                    if (error.status === 401) {
                        this.auth.navigateToLogin();
                        return;
                    }
                })
            );
    }
}
